import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { debugEndpoints } from '@/modules/debug/constants';

import { debugQueryKeys } from './queryKeys';

export const useJobSourcingDebugQuery = (jobId: string) => {
  return useQuery({
    queryKey: debugQueryKeys.jobSourcing(jobId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(debugEndpoints.jobSourcing, {
        params: { path: { jobId } },
      });
      return data;
    },
    enabled: !!jobId,
  });
};
